import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const BlockedIcon = ({size, color, onClick, intl, shouldShow}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '16';
			default:
				return '14';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '16';
			default:
				return '16';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan
			onClick={handleClick}
			width={getWidth(size)}
			height={getHeight(size)}
			title={intl.formatMessage({id: 'common.blocked'})}
			shouldShow={shouldShow}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width={getWidth(size)} height={getHeight(size)} viewBox="0 0 16 16">
				<path
					fill={color}
					fillRule="evenodd"
					d="M8 1.6A6.407 6.407 0 0 0 1.6 8c0 3.529 2.87 6.4 6.4 6.4 3.528 0 6.4-2.871 6.4-6.4 0-3.529-2.872-6.4-6.4-6.4zM8 16c-4.412 0-8-3.589-8-8s3.588-8 8-8 8 3.589 8 8-3.588 8-8 8zm3.765-10.635L9.131 8l2.634 2.634-1.13 1.131L8 9.132l-2.635 2.633-1.13-1.131L6.867 8 4.234 5.365l1.131-1.131L8 6.868l2.634-2.634 1.131 1.131z"
				/>
			</svg>
		</StyledSpan>
	);
};

BlockedIcon.SIZE = SIZE;
BlockedIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	shouldShow: PropTypes.bool,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	intl: PropTypes.shape({
		formatMessage: PropTypes.func,
	}),
};

BlockedIcon.defaultProps = {
	color: CSS_CONSTANTS.v2_border_invalid,
	intl: {
		formatMessage: ({id}) => id,
	},
};

export const StyledSpan = Styled.span`
	display: ${props => (props.shouldShow ? 'inline' : 'none')}; // Dirty hack for google translate
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	svg{
		vertical-align:text-top;
	}
`;
